
  import * as ipxRuntime$_9eDw_08Yw3Cu4sClOEi_q4aakoTSwXvabgRsVNP3PmU from '/var/www/frontend/reviewapp-production/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['ipx']: { provider: ipxRuntime$_9eDw_08Yw3Cu4sClOEi_q4aakoTSwXvabgRsVNP3PmU, defaults: {} }
    }
  }
